import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/conference-events/profile/loading';

export const Route = createFileRoute('/_private/conferences-and-events/$id')({
  pendingComponent: Loading,
});
